import React, { useState, useContext } from "react";
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import MemberContext from "../../../context/MemberProvider";
import {
    addMessage,
    getPortalUserByEmail
} from "../../../api/apiServices";
import toast, { Toaster } from 'react-hot-toast'

const ContactProforum = ({ }) => {
    const { mem } = useContext(MemberContext)
    const memberEmail = mem.email;

    const [fullname, setFullname] = useState("")
    const [pf_number, setPfNumber] = useState("")
    const [email, setEmail] = useState("")
    const [mobile_number, setMobileNumber] = useState("")
    const [message, setMessage] = useState("")

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/home";

    const {
        data: portal_member
    } = useQuery(['portal_user', memberEmail], () => getPortalUserByEmail(memberEmail), {
        onSuccess: async (res) => {
            setFullname(res.first_name + " " + res.middle_name + " " + res.last_name);
            setPfNumber(res.pf_number);
            setEmail(res.email);
            setMobileNumber(res.mobile_number);
        },
        onError: async (err) => {
            toast.error(err)
        }
    });

    const addMessageMutation = useMutation(addMessage, {
        onSuccess: async (res) => {
            toast.success(res, {
                duration: 5000
            })
            setMessage("")
        },
        onError: async (err) => {
            toast.error(err)
        }
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        const msgData = {
            fullname: fullname,
            pf_number: pf_number,
            email: email,
            mobile_number: mobile_number,
            message: message
        }
        addMessageMutation.mutate(msgData);
    }

    const handleCancel = () => {
        navigate(from, { replace: true });
    }
    const contactForm = (<>
        <form onSubmit={handleSubmit}>
            <div className="form-group row">
                <label htmlFor="title" className="col-sm-2 label-name">Full Name<span>&nbsp;&nbsp;*</span></label>
                <div className="col-sm-6">
                    <input
                        type="text"
                        name="name"
                        style={{ textTransform: "capitalize" }}
                        value={fullname}
                        onChange={(e) => setFullname(e.target.value)}
                        readOnly
                        className="form-control"
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="title" className="col-sm-2 label-name">PF Number<span>&nbsp;&nbsp;*</span></label>
                <div className="col-sm-6">
                    <input
                        type="text"
                        name="pf_number"
                        style={{ textTransform: "capitalize" }}
                        value={pf_number}
                        onChange={(e) => setPfNumber(e.target.value)}
                        readOnly
                        className="form-control"
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="title" className="col-sm-2 label-name">Email Address<span>&nbsp;&nbsp;*</span></label>
                <div className="col-sm-6">
                    <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        readOnly
                        className="form-control"
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="title" className="col-sm-2 label-name">Mobile Number<span>&nbsp;&nbsp;*</span></label>
                <div className="col-sm-6">
                    <input
                        type="number"
                        name="mobile_number"
                        value={mobile_number}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        readOnly
                        className="form-control"
                    />
                </div>
            </div>
            <div className="form-group row">
                <label htmlFor="title" className="col-sm-2 label-name">Message<span>&nbsp;&nbsp;*</span></label>
                <div className="col-sm-6">
                    <textarea
                        name="message"
                        placeholder="Enter your message"
                        required
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        maxLength="1000"
                        cols="30"
                        rows="10"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="panel-footer">
                <div className="form-group row">
                    <div className="col-sm-2">
                        <button type="submit" className="btn btn-success" name="submit">Submit</button>&nbsp; &nbsp;&nbsp; &nbsp;
                        <button className="btn btn-danger" onClick={handleCancel}>Cancel </button>
                    </div>
                </div>
            </div>
        </form>
    </>)
    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1>Contact PROFORUM </h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Send Message to PROFORUM</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {contactForm}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactProforum;
